module.exports = __webpack_public_path__ + "img/goodness-21.e6d0fcbf.png";